import { CanDeactivateFn } from '@angular/router';

/**
 * Components that need to intercept navigation away from their route implement
 * this. The guard simply delegates to the component's own `canDeactivate`, which
 * may return a Promise (e.g. after awaiting a confirmation dialog).
 */
export interface CanComponentDeactivate {
  canDeactivate: () => boolean | Promise<boolean>;
}

export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component,
  _currentRoute,
  currentState,
  nextState,
) => {
  // A navigation to the very URL the page is already on reuses the component instance: nothing is
  // lost, so there is nothing to ask — and a page that refuses to be left must not refuse to stay.
  // These happen because onSameUrlNavigation is 'reload' app-wide: every Back press that
  // HoldBackButtonDirective absorbs is one, and so is Forward after a refused Back.
  if (nextState?.url === currentState.url) return true;
  return component?.canDeactivate ? component.canDeactivate() : true;
};
